import React from 'react';

export const conditionGroupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
};

export const conditionGroupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#172B4D',
    display: 'inline-block',
    fontSize: 12,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
};

export const formatConditionGroupLabel = data => (
    <div style={conditionGroupStyles}>
        <span>{data.label}</span>
        <span style={conditionGroupBadgeStyles}>{data.options.length}</span>
    </div>
);

const formatDatePart = (day, month, year) => {
    if (year == null) return null;
    if (day != null && month != null) {
        const d = String(day).padStart(2, '0');
        const m = String(parseInt(month) + 1).padStart(2, '0');
        return `${d}/${m}/${year}`;
    }
    return String(year);
};

// idKey/labelKey permiten reutilizar el mismo formateo sobre distintas formas de opción
// (ConditionOption de MedicalRecords usa id/adverseEffect; las opciones de Protocols usan conceptId/description).
export const formatConditionOptionLabel = (option, t, idKey = 'id', labelKey = 'adverseEffect') => {
    if (option[idKey] === 0) return option[labelKey];

    const startStr = formatDatePart(option.fromDay, option.fromMonth, option.fromYear);
    const endStr = formatDatePart(option.toDay, option.toMonth, option.toYear) ?? t('medicalRecords.indicationReason.ongoing');

    if (startStr) return `${option[labelKey]} ${t('medicalRecords.indicationReason.since')} ${startStr} ${t('medicalRecords.indicationReason.to')} ${endStr}`;
    return option[labelKey];
};
